import { wizardsReducer } from '@asicsdigital/oneasics-blocks';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import localForage from 'localforage';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
} from 'redux-persist';

import { contentfulApi } from '../services/api';
import tokensReducer from './tokensSlice';

const combinedReducers = combineReducers({
  [contentfulApi.reducerPath]: contentfulApi.reducer,
  tokens: tokensReducer,
  wizards: wizardsReducer,
});

const persistConfig = {
  key: 'root',
  storage: localForage,
};

const persistedReducer = typeof window !== 'undefined' ?
  persistReducer(persistConfig, combinedReducers) :
  {
    [contentfulApi.reducerPath]: contentfulApi.reducer,
    tokens: tokensReducer,
    wizards: wizardsReducer,
  };

/**
 * currently refreshes are wiping all data in the get.
 */
export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
  }).concat(contentfulApi.middleware),
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
